import { BOOKS_GALLERY_BASE_FILTER } from '#lib/websites/shop/constants/books-gallery.js';
import type { Publishing_Books_Filter } from '$gql/types';

interface GetArtistPublishingBooksFilterArgs {
	slug: string | null | undefined;
	name: string | null | undefined;
}

/**
 * The books shown on an artist page: those explicitly linked to the global
 * artist through the curated global_artist_page_config junction, plus those
 * naming the artist through the publishing-side Publishing_Books.artists
 * relation. The two artist collections are unrelated in Directus, so the
 * publishing side can only be matched by name — the same match /shop/all uses
 * for its artist facet, keeping this section consistent with its own
 * "View all books" link.
 *
 * The shop gallery's base filter collapses preview-only series (e.g. Shantell
 * Martin's "Lines (Limited Edition)") to their single featured book, which
 * BooksGalleryItem then renders as one series card.
 */
export const getArtistPublishingBooksFilter = ({
	slug,
	name,
}: GetArtistPublishingBooksFilterArgs): Publishing_Books_Filter => ({
	_and: [
		{
			_or: [
				{
					global_artist_page_config: {
						Artists_id: { slug: { _eq: slug ?? '' } },
					},
				},
				...(name
					? [
							{
								artists: {
									Publishing_Authors_And_Artists_id: {
										full_name: { _eq: name },
									},
								},
							},
						]
					: []),
			],
		},
		BOOKS_GALLERY_BASE_FILTER,
	],
});
